<template>
  <div v-if="incomingTenderAlerts.length" class="d-contents">
    <div v-for="alert in incomingTenderAlerts" :key="alert.id" class="d-contents">
      <div v-if="get(alert, 'marked_up_content.blocks[0].data.text')" class="d-contents">
        <AlertMessage @close="closeAlert(alert.id)">
          <span v-html="alert.marked_up_content.blocks[0].data.text" />
        </AlertMessage>
      </div>
    </div>
  </div>
</template>

<script>
  import incomingTenderAlertsSubscription from '@/gql/alerts/incoming-tender-alerts.graphql';
  import AlertMessage from '@/components/alerts/AlertMessage';
  import get from 'lodash.get';
  import request from '@/utils/api/request';
  import factory from '@/utils/api/factory';

  export default {
    name: 'IncomingTenderAlertBlock',
    components: {
      AlertMessage,
    },
    apollo: {
      $subscribe: {
        alerts() {
          return {
            query: incomingTenderAlertsSubscription,
            variables() {
              return {
                tender_offer_id: this.incomingTenderId,
              };
            },
            result() {
              this.uploadAlerts();
            },
          };
        },
      },
    },
    computed: {
      incomingTenderId() {
        return this.$route.params.incomingTenderId;
      },
    },
    data() {
      return {
        incomingTenderAlerts: [],
      };
    },
    methods: {
      get,
      async closeAlert(id) {
        try {
          this.incomingTenderAlerts = this.incomingTenderAlerts.filter((alert) => alert.id !== id);
          await request.post(`/alerts/${id}/read/`);
        } catch (e) {
          console.error(e);
        }
      },
      async uploadAlerts() {
        try {
          let { data } = await factory('alerts').index({
            tender_offer_id: this.incomingTenderId,
          });
          this.incomingTenderAlerts = data;
        } catch (e) {
          console.error(e);
        }
      },
    },
  };
</script>
